/** Splits "Good evening Eden." → { prefix: "Good evening ", name: "Eden", suffix: "." } */
export function splitGreeting(greeting: string) {
  const match = greeting.match(/^(.*\s)([A-Za-z''\\-]+)([^A-Za-z''\\-].*)$/);
  if (!match) return null;
  return { prefix: match[1], name: match[2], suffix: match[3] };
}
